import BaseContainer from '@/components/BaseContainer';
import { Box, Stack } from '@chakra-ui/react';
import ContactUsHero from './ContactUsHero';
import GetInTouch from './GetInTouch';

const ContactUsContainer = () => {
  return (
    <>
      <Box>
        <Stack
          pt={24}
          w='full'
          bgSize={'cover'}
          bgImage={`/images/contact-us/get-in-touch.webp`}
          bgRepeat={'no-repeat'}
          bgPosition={'center'}
          minH={{ base: 600, lg: 750 }}
          position='relative'
          _before={{
            content: `""`,
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            bgGradient:
              'linear(to-r, rgba(255, 255, 255, 0.75) 20%, rgba(255, 255, 255, 0) 50%)',
          }}
        >
          <BaseContainer position='relative' zIndex='docked'>
            <ContactUsHero />
          </BaseContainer>
        </Stack>
      </Box>
      <BaseContainer>
        <GetInTouch />
      </BaseContainer>
    </>
  );
};

export default ContactUsContainer;
